export const editablePlugins = [
  'Text Input',
  'Text Area',
  'Number slider',
  'Inline Text Input',
  'Tooltip',
  'Inline Icon v2',
];